module.exports = __webpack_public_path__ + "media/assets/images/layout/ontario-logo-partnership-footer-2b9ac42d136e3c71caafbff1cf93f39f.svg";